<template>
<!-- 一封信测评 -->
  <div class="ceping82-main  animated fadeInRight">
      <img class="bg" src="https://themes-cdn.xjy.cn/statics/career/images/ceping82/cp82-b1.png" alt="">
      <div :class="['btn',bool?'on':'',h?'top':'bottom']">
          <!-- <router-link  :to="`/ceping82_call`">写一封信</router-link> -->
          <a href="javascript:;" @click="start">写一封信</a>
      </div>
      <!-- 返回书房 -->
      <div class="mail-list" v-if="mailBool" @click="$router.push('/ceping82_bookList');">
          <div class="mail-icon">
              <van-icon name="envelop-o"  />
          </div>
          <div class="mail-text">
              返回<br/>书房
          </div>
      </div>
      <!-- 关注二维码 -->
    <van-popup class="radius" :close-on-click-overlay="false" v-model="followShow">
      <div class="pop pr text-center">
        <p>长按识别关注公众号</p>
        <p>发送“写信”开始吧！</p>
        <div class="text-center">
          <img class="qr-box" :src="info.qrcode" alt="" />
        </div>
      </div>
    </van-popup>

    <!-- 填写个人资料 -->
    <answer-collect :cid="data.cid" :query="$route.query" :extraObj="extraObj" v-if="userInfoBool" @saveuserinfo="saveUserInfo"></answer-collect>
  </div>
</template>

<script>
import { ceping82_get_data_list,ceping82_info,ceping_event,ceping82_save_extra,get_extra_info, } from '@/api/measurement'
import { shareCon } from "@/utils/wxconfig";
import AnswerCollect from "@c/measurement/answer-collect";
import { phoneValidation } from '@/utils/validation'

export default {
    data(){
        return{
            bool:false,
            h:false,
            cid:82,
            mailBool:false,
            info:{},
            // 是否关注生涯研习社
            followShow:false,
            data: {
                cid: 82
            },
            // 存储答题数据
            extra:{},
            extraObj:{},
            userInfoBool:false,
            queArr:[],
        }
    },
    components: {
      AnswerCollect,
    },
    mounted(){
        this.h = (document.body.offsetHeight | document.body.clientHeight)>574?true:false;
        $(window).scroll(()=>{
            this.bool = $(document).scrollTop() >35?true:false;
        });
    },
    methods:{
        // 初始化获取数据
        pullData(){
            document.title = "最好的礼物，是你的祝福";
            //调用加载中
            this.$emit('loadingHandle',true,"正在准备物料ヾ(◍°∇°◍)ﾉﾞ...");
            ceping82_get_data_list({
                cid:this.cid
            }).then((data)=>{
                //关闭加载中
                this.$emit('loadingHandle',false);
                if (data.code == "10002") {
                    this.$toast(data.data.msg || data.msg || data.data.detail);
                    return
                }
                this.mailBool = data.list.length>0?true:false;
                
                
            });
            // 获取用户信息
            ceping82_info().then((data)=>{
                if (data.code == "10002") {
                    this.$toast(data.data.msg || data.msg || data.data.detail);
                    return
                }
                this.info = data;
                this.followShow = !data.subscribe && data.need_subscribe;

                this.extraObj = data.extra || {};
            });
            shareCon("index", this);

            ceping_event({ lead_sid: this.$route.query.lead_sid,
              cid: this.cid,
              event: 'ViewIndex',
            }).then(res=>{
              // 页面访问统计
            });
        },
        start() {
            let bool = true;
            get_extra_info().then(data=>{
              for(let i=0;i<Object.keys(this.extraObj).length;i++){
                let item = Object.keys(this.extraObj)[i];
                if(data.extra[item]){
                  this.extra[item] = data.extra[item];
                }else{
                  bool = false;
                }
              }

              if(bool){
                this.next();
              }else{
                this.userInfoBool = true;
              }
            });
        },
        next() {
            this.$router.push('/ceping82_call');
        },
        // 提交个人信息和答题数据
        saveUserInfo(extra){
            if(extra) {
              this.extra = extra;
            }
            
            let obj = {};
            if(this.$route.query.sid){
                obj['sid'] = this.$route.query.sid;
            }
            for(let i=0;i<Object.keys(this.extraObj).length;i++){
              let item = Object.keys(this.extraObj)[i];
              if(!this.extra[item]){
                this.$toast(`${this.extraObj[item]}不能为空！`);
                return
              }else if(!phoneValidation(this.extra.phone)){
                this.$toast('手机号格式不正确！');
                return
              }else{
                obj[item] = this.extra[item];
              }
            }
            
            this.$toast.loading({
              mask: true,
              message: "提交中..."
            });

            ceping82_save_extra(obj).then(data=>{
                if (data.code == 10002) {
                    this.$toast(data.msg);
                    return;
                }
                this.next();
            });
        },
    },
    created(){
        this.pullData();
    }
}
</script>
<style lang="scss">
    body{
        background:url('https://themes-cdn.xjy.cn/statics/career/images/ceping82/bg-cover.png') bottom;
    }
</style>
<style lang="scss" scoped>
.ceping82-main{
    overflow-y: auto;
    position: relative;
    .bg{
        width: 100%;
    }
    .btn{
        display: block;
        position: fixed;
        left: 50%;
        transform: translateX(-50%);
        a{
            width: 300px;
            line-height: 80px;
            height: 80px;
            background: linear-gradient(180deg, #FF855D 0%, #D13E1D 100%);
            box-shadow: 0px 2px 6px 0px rgba(179, 31, 0, 0.43);
            border-radius: 40px;
            display: block;
            text-align: center;
            text-shadow: 0px 2px 4px rgba(221, 41, 0, 0.5);
            font-size: 36px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #FFFFFF;
            animation: scaleDraw 2s  infinite;
        }
    }
    .btn.top{
        top: 1145px;
    }
    .btn.bottom{
        bottom: 110px;
    }
    .btn.on{
        position: absolute;
    }
    .mail-list{
        position: fixed;
        top: 40px;
        right: 30px;
        width: 90px;
        height: 90px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        text-align: center;
        .mail-text{
            position: absolute;
            left: 0;
            top: 0;
            width: 90px;
            height: 90px;
            line-height: 30px;
            background: linear-gradient(180deg, #FF855D 0%, #D13E1D 100%);
            box-shadow: 0px 2px 6px 0px rgba(179, 31, 0, 0.43);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            text-shadow: 0px 2px 4px rgba(221, 41, 0, 0.5);
            font-size: 24px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            // transform:rotateY(180deg);
            color: #FFFFFF;
        }
        /*
            反转效果
        */
        @keyframes rotateYDraw {  
            from { /*动画起始状态*/
                transform: rotateY(0deg);
            }
            to { /*动画结束状态*/
                transform: rotateY(360deg);
            }
        }
    }
    .radius {
        border-radius: 10px;
    }
    .pop {
        width: 8rem;
        padding-bottom: 80px;
        p:nth-child(1) {
            padding-top: 50px;
            font-size: 34px;
            line-height: 80px;
            font-weight: bold;
            color: #F57F17;
        }
        p:nth-child(2) {
            color: #333;
            font-size: 30px;
            line-height: 80px;
        }
        img {
            width: 80%;
        }
    }

}
</style>